import dayjs from "dayjs";
import MiniInfoCard from "@lib/components/MiniComponents/Dashboard/MiniInfoCard";
import { green } from "@ant-design/colors";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiGetXAICalls } from "@lib/api/xAI";
import { FaPhone } from "react-icons/fa";
import { AppCardProps } from "@lib/components/AppComponents/AppCard";
import { ROUTES } from "@lib/constants";

type Props = {
  cardProps?: AppCardProps;
};

export default function TftSalesCallsMiniCard(props: Props) {
  const { cardProps } = props;
  const { messages } = useIntl();
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ["dashboard-minicard-tft-sales-calls"],
    queryFn: () =>
      apiGetXAICalls({
        sort: "createdAt,DESC",
        limit: 10000,
      }),
  });

  const apiData = data?.data?.data;
  const total = apiData?.length || 0;

  const todayTotal =
    apiData?.filter((d) => {
      const createdAt = dayjs(d.createdAt);
      const startOfToday = dayjs().startOf("day");
      const endOfToday = dayjs().endOf("day");

      return createdAt.isBetween(startOfToday, endOfToday, null, "[]");
    })?.length || 0;

  const handleNavigate = () => {
    navigate(ROUTES.ADMIN.TFT_SALES.CALL_LIST);
  };

  return (
    <MiniInfoCard
      loading={isLoading}
      navigate={handleNavigate}
      cardProps={cardProps}
      data={{
        icon: <FaPhone />,
        color: green[5],
        desc: (
          <FormattedMessage
            id="common.totalX"
            values={{ x: messages["sidebar.tftSalesCalls"] as string }}
          />
        ),
        title: total,
        rightMenu: {
          key: "new",
          data: {
            data: todayTotal,
            duration: messages["common.today"] as string,
          },
        },
      }}
    />
  );
}
